<template>
  <div class="super-food-page">
    <AppBar title="" :options="appBarOptions" :z-index="10" v-if="curEv == 0">
      <div slot="right" @click="bindShowShare">
        <img
          class="share-btn"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/11154b7ec95a8c184ba5bd17f394f9de.png"
          alt=""
        />
      </div>
    </AppBar>
    <div
      class="super-food"
      id="super-food"
      :style="{
        backgroundColor:
          superFoodList[activeIndex] &&
          superFoodList[activeIndex].data &&
          superFoodList[activeIndex].data.s_color
      }"
    >
      <div class="detail-container">
        <div
          class="food-image-container"
          id="food-image-container"
          :class="{
            'food-image-container-open':
              superFoodList[activeIndex] && superFoodList[activeIndex].open
          }"
        >
          <div class="food-image-padding" v-if="superFoodList[activeIndex]">
            <img
              class="food-text-image"
              v-if="superFoodList[activeIndex].data"
              :src="superFoodList[activeIndex].data.s_sub_img"
              alt=""
            />
            <img
              class="food-image"
              v-if="superFoodList[activeIndex].data"
              :src="superFoodList[activeIndex].data.s_image"
              alt=""
            />
          </div>
        </div>
        <!--  -->
        <div class="swiper mySwiper" id="my-swiper">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in superFoodList"
              :key="index"
            >
              <div
                class="card-container"
                v-show="index >= activeIndex - 1 && index <= activeIndex + 1"
              >
                <div class="more" ref="more" v-show="!item.open">
                  <span>上滑查看更多</span>
                  <span class="iconfont icon-xiangshangzhanhang"></span>
                  <!--   <span v-show="item.open">下拉收起</span> -->
                </div>
                <div class="item-card" :class="{ 'item-card-open': item.open }">
                  <div class="card-loading" v-if="!item.loaded">加载中</div>
                  <div class="card-show" v-show="index == activeIndex">
                    <div class="card-icon" @click="toggleItem(index, true)">
                      <div class="icon-1"></div>
                      <div class="icon-2"></div>
                    </div>
                    <div
                      class="card-flex"
                      :class="{ 'card-scroll': item.open }"
                      :ref="'cardItem' + index"
                      @scroll="bindCardScroll"
                    >
                      <!-- 11111 -->
                      <div v-if="item.loaded && item.data">
                        <div class="c-padding">
                          <div class="card-title">
                            <span class="title1">{{ item.data.s_title }}</span
                            ><span class="title2">SUPER FOOD</span>
                          </div>
                          <div class="card-top">
                            <div class="top-left">
                              <span class="food-name">{{
                                item.data.s_food_name
                              }}</span>
                              <span class="food-type">{{
                                item.data.classifier_name
                              }}</span>
                            </div>
                            <div class="collect-box">
                              <img
                                class="collect"
                                :src="collectIcon"
                                @click="bindCollect(item.data)"
                                alt=""
                              />
                              <div class="collect-num">{{
                                item.data.collect_info.collect_num
                              }}</div>
                            </div>
                          </div>
                          <!-- 热量信息 -->
                          <div class="item-cal">
                            <span class="cal-num">{{ item.data.calory }}</span>
                            <span class="cal-100unit">千卡 / 百克</span>
                          </div>
                          <!-- 亮点 -->
                          <div class="tag-list">
                            <div
                              class="tag-item"
                              v-for="(item1, index1) in item.data.tagList"
                              :key="index1"
                            >
                              {{ item1 }}
                            </div>
                          </div>
                          <!-- 推荐原因 -->
                          <div class="recommend-list">
                            <div
                              class="recommend-item"
                              v-for="(item1, index1) in item.data
                                .s_suggest_desc"
                              :key="index1"
                            >
                              {{ item1 }}
                            </div>
                          </div>
                          <!-- 食物热量指数 -->
                          <div class="gray-item food-cal">
                            <p class="item-title">食物热量</p>
                            <p class="item-desc">每100克可食用部分</p>
                            <div class="circle-container">
                              <CalCanvas
                                :min="0"
                                :max="500"
                                :value="item.data.calory || 0"
                              />
                            </div>
                          </div>
                          <!-- 营养成分 -->
                          <div
                            class="gray-item nutrition-container"
                            v-if="item.data._list.length"
                          >
                            <p class="item-title">营养成分表</p>
                            <p class="item-desc">每100克营养含量</p>
                            <div class="nutrition-box">
                              <div class="nutrition-item nutrition-item-title">
                                <span class="item-name">营养元素</span>
                                <span class="item-unit">含量（每100g）</span>
                                <!--   <span class="item-percent">NRV%</span> -->
                              </div>
                              <div
                                class="nutrition-item"
                                v-for="(item1, index1) in item.data._list"
                                :key="index1"
                                v-show="item.showMoreNutrition || index1 <= 5"
                              >
                                <span class="item-name">{{ item1.name }}</span>
                                <span class="item-unit">{{
                                  item1.value + item1.unit_en
                                }}</span>
                              </div>
                              <div
                                class="look-more"
                                @click="bindMoreNutrition(index)"
                              >
                                <div>
                                  <span class="text">{{
                                    item.showMoreNutrition ? '收起' : '查看更多'
                                  }}</span
                                  ><span
                                    class="iconfont icon-black"
                                    :class="{ rotate: item.showMoreNutrition }"
                                  ></span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="gray-item bloodsugar-container"
                            v-if="item.data.gi || item.data.gl"
                          >
                            <p class="item-title">血糖相关</p>
                            <p class="item-desc">血糖提升的关键指数</p>
                            <div class="bloodsugar-list">
                              <div class="bloodsugar-item" v-if="item.data.gi">
                                <div class="item-title">GI</div>
                                <div class="item-number">
                                  {{ item.data.gi | filterFloat }}
                                </div>
                                <div class="item-desc">
                                  {{ item.data.gi | filterGi }}
                                </div>
                              </div>
                              <div class="bloodsugar-item" v-if="item.data.gl">
                                <div class="item-title">GL</div>
                                <div class="item-number">
                                  {{ item.data.gl | filterFloat }}
                                </div>
                                <div class="item-desc">
                                  {{ item.data.gl | filterGl }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- 食用建议 -->
                          <div
                            class="gray-item edible-advice"
                            v-if="item.data.s_suggest_eat.length"
                          >
                            <p class="item-title">食用建议</p>
                            <p class="item-desc">这样吃，不出错</p>
                            <div class="recommend-list">
                              <div
                                class="recommend-item"
                                v-for="(item1, index1) in item.data
                                  .s_suggest_eat"
                                :key="index1"
                              >
                                {{ item1 }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- 资源位 -->
                        <AdvComponent
                          class="adv-content"
                          :data="item.advData"
                        />
                        <div class="c-padding">
                          <!-- 超级菜谱 -->
                          <div
                            class="gray-item super-menu"
                            v-if="item.superMenuList.length"
                          >
                            <p class="item-title" :ref="'superMenu' + index">
                              超级菜谱
                            </p>
                            <p class="item-desc">动手做，是对平凡生活的热爱</p>
                            <div class="menu-list">
                              <div
                                class="menu-item"
                                v-for="(
                                  menuitem, menuindex
                                ) in item.superMenuList"
                                :key="menuindex"
                                @click="bindJumpRecipe(index, menuindex)"
                              >
                                <img
                                  class="item-pic"
                                  :src="menuitem.icon"
                                  alt=""
                                />
                                <div class="item-bottom">
                                  <div class="item-name">{{
                                    menuitem.name
                                  }}</div>
                                  <div class="menu-desc">{{
                                    menuitem.desc
                                  }}</div>
                                  <div class="item-star">
                                    <div>
                                      <span class="item-diff">难度</span>
                                      <van-rate
                                        class="star"
                                        v-model="menuitem.difficulty_degree"
                                        :gutter="0"
                                        :size="12"
                                        color="#FFAF49"
                                        void-icon="star"
                                        void-color="#D8D8D8"
                                      />
                                    </div>
                                    <div>
                                      用时{{ menuitem.make_stime }}-{{
                                        menuitem.make_etime
                                      }}分钟
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="look-more"
                              v-if="item.superMenuList.length"
                              @click="bindMore"
                            >
                              <span class="text">查看更多优质菜谱</span
                              ><span
                                class="iconfont icon-black rotate90"
                              ></span>
                            </div>
                          </div>
                          <div class="tip"
                            >数据信息源自：<br />中国食物成分表标准版（第6版）2019年出版</div
                          >
                        </div>
                      </div>
                    </div>
                    <!--111111 底部营养师信息 -->
                    <div
                      class="card-bottom"
                      @click="jumpToStarPage"
                      v-if="item.loaded && item.data && CommonIncomingData"
                    >
                      <img
                        :src="CommonIncomingData.head_portrait"
                        class="avatar"
                        alt=""
                        v-buried
                        data-buried="BG_CJSW_YYSZY"
                        v-clickBuried
                        data-click-buried="CLICK_CJSW_YYSZY"
                      />
                      <div class="bottom-right">
                        <p class="nickname">{{ CommonIncomingData.name }}</p>
                        <p class="desc"> 怎么搭配能加倍提升减脂效率? </p>
                      </div>
                      <div
                        class="b-btn"
                        @click.stop="jumpIncoming"
                        v-clickBuried
                        data-click-buried="CLICK_CJSW_ZX"
                        >立即咨询</div
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 底部 -->
        <div class="bottom">
          <div class="download-container" v-if="curEv == 2 && loaded">
            <img
              class="betterwe-logo"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/betterwe_logo.png"
              alt=""
            />
            <div class="center">
              <div class="text1">打开betterWE</div>
              <div class="text2">了解更多更全食物知识</div>
            </div>
            <div
              class="app-btn"
              @click="copyStr"
              ref="copy"
              :data-clipboard-text="str"
            >
              打开APP
            </div>
          </div>
          <img
            v-else
            class="logo"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9569c0b5ad78d89c1153c698aeb1be50.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <van-overlay
      :show="showShare"
      @click="showShare = false"
      z-index="99"
      @touchstart.stop="bindStop"
      @touchmove.stop="bindStop"
      @touchend.stop="bindStop"
    >
      <ShareComponent @close="showShare = false" @share="bindShare" />
    </van-overlay>
    <div v-if="!loaded" class="space-loading">
      <div class="more">
        <span>上滑查看更多</span>
        <span class="iconfont icon-xiangshangzhanhang"></span>
      </div>
      <div class="space-content">
        <div class="item">
          <span class="gray gray-1"></span>
        </div>
        <div class="item">
          <span class="gray gray-2"></span>
        </div>
        <div class="item radius-content">
          <span class="gray gray-radius radius-1"></span>
          <span class="gray gray-radius radius-2"></span>
          <span class="gray gray-radius radius-3"></span>
        </div>
        <div class="item">
          <span class="gray gray-3"></span>
        </div>
        <div class="item">
          <span class="gray gray-4"></span>
        </div>
        <div class="item">
          <span class="gray gray-5"></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper/swiper-bundle.min.js'
import 'swiper/swiper-bundle.min.css'
import Clipboard from 'clipboard'
import ShareComponent from './ponents/share-content.vue'
import AdvComponent from '@/components/app/advertisement/advertisement.vue'
import CalCanvas from './ponents/cal-canvas.vue'
import AppBar from '@/components/app/nav-bar/index.vue'
export default {
  components: { ShareComponent, CalCanvas, AdvComponent, AppBar },
  data() {
    return {
      appBarOptions: {
        barBackgroundColor: 'transparent'
      },
      starNum: 3,
      cardHeight: 0, //卡片高度
      textHeight: 0,
      imageHeight: 0,
      str: '', //邀请关系字符串
      curEv: 2, //当前页面环境  ["app","小程序","h5"]
      cardInfo: {
        startx: 0,
        starty: 0,
        prey: 0
      },
      loaded: false,
      swiper: null,
      isInit: false, // 是否初始化轮播图
      activeIndex: 0,
      currentRate: 50,
      gradientColor: {
        '0%': '#4A3D6B',
        '50%': '#6236FF',
        '100%': '#FF2B48'
      },
      showShare: false,
      circleSize: '220px',
      superFoodList: [],
      clipboard: null, //黏贴板
      /* 资源位数据 */
      advData: [],
      collect: false,
      CommonIncomingData: null
    }
  },
  computed: {
    //获取亮点标签盒子的大小信息
    tagSizeInfo() {
      let res = {}
      //字体大小3.2vw
      res.fontSize = window.screen.width * 0.032
      //父元素宽度 = 84%手机宽度 - padding5.33vw * 2
      res.tagContainerWidth =
        window.screen.width * 0.84 - 0.0533 * window.screen.width * 2
      //标签的padding宽度
      res.tagPadding = window.screen.width * 0.032
      //标签的margin宽度
      res.tagMargin = window.screen.width * 0.0107
      return res
    },
    collectIcon() {
      return this.superFoodList[this.activeIndex].data.collect_info.is_collect
        ? 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/762d32b08bd955a6d856dab74f0ad57e.png'
        : 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/238311191b2ef765ebf8104f14406a78.png'
    }
  },
  filters: {
    filterFloat(val) {
      return parseFloat(val)
    },
    filterGi(val) {
      let res = ''
      if (val >= 70) {
        res = '高GI'
      } else if (val <= 55) {
        res = '低GI'
      } else {
        res = '中GI'
      }
      return res
    },
    filterGl(val) {
      let res = ''
      if (val >= 20) {
        res = '高GL'
      } else if (val <= 10) {
        res = '低GL'
      } else {
        res = '中GL'
      }
      return res
    }
  },
  watch: {
    activeIndex(index) {
      if (!this.superFoodList[index].loaded) {
        this.getSuperFood(this.superFoodList[index].foodId)
      }
      this.closeBettwen(index)
    }
  },
  created() {
    this.init()
    this.getCommonIncomingUrl()
  },
  mounted() {
    this.getSuperFood(this.$route.query.id)
  },
  methods: {
    init() {
      this.bindumaInto()
      this.getEnv()
    },
    //进入页面埋点
    bindumaInto() {
      if (this.$route.query.from == '511guanggao' && this.$route.query.id) {
        this.$http.addLog(
          '超级食物511活动微信落地页曝光id=' + this.$route.query.id
        )
      }
    },
    closeBettwen(index) {
      if (
        index - 1 >= 0 &&
        index - 1 < this.superFoodList.length &&
        this.superFoodList[index - 1].loaded &&
        this.superFoodList[index - 1].open
      ) {
        this.closeItem(index - 1, true)
      }
      if (
        index + 1 >= 0 &&
        index + 1 < this.superFoodList.length &&
        this.superFoodList[index + 1].loaded &&
        this.superFoodList[index + 1].open
      ) {
        this.closeItem(index + 1, true)
      }
    },
    getParams() {
      this.str = this.$route.query._str || ''
      if (this.str) {
        this.clipboard = new Clipboard(this.$refs.copy)
      }
    },
    copyStr() {
      if (!this.clipboard) {
        this.openApp()
        return
      }
      this.clipboard.on('success', (e) => {
        this.openApp()
      })
      this.clipboard.on('error', (e) => {
        this.openApp()
      })
    },
    openApp() {
      if (this.$route.query.from == '511guanggao' && this.$route.query.id) {
        this.$http
          .addLog(
            '超级食物511微信落地页打开app按钮点击id=' + this.$route.query.id
          )
          .finally(() => {
            location.href =
              'https://member3.gymcity.com.cn/#/app-download?token=' +
              localStorage.getItem('token')
          })
      }
    },
    getEnv() {
      if (this.$http._isApp() || this.$route.query.isApp) {
        this.curEv = 0
      } else {
        wx.miniProgram.getEnv((res) => {
          if (res.miniprogram) {
            this.curEv = 1
          } else {
            this.curEv = 2
          }
        })
      }
    },
    initSwiper() {
      let self = this
      this.$nextTick(() => {
        this.swiper = new Swiper('.mySwiper', {
          slidesPerView: 'auto', //每页显示数量，auto为自动填充，3为每页显示3块
          centeredSlides: true, //轮播图自动居中
          spaceBetween: '0%', //轮播图左右之间的间距，配合css样式中的width实现效果
          initialSlide: 0, //轮播图初始下标位置
          autoHeight: false,

          //方法事件
          on: {
            //回调函数，swiper从当前slide开始过渡到另一个slide时执行
            slideChange: function () {
              self.activeIndex = this.activeIndex
            }
          }
        })
      })
      this.$nextTick(() => {
        this.bindTouchDom('food-image-container')
        this.bindTouchDom('my-swiper')
        //this.bindTouch();
        //this.disabledWxRefresh();
      })
    },
    bindShowShare() {
      this.showShare = true
    },
    bindCollect(data) {
      if (!this.$http._isApp()) {
        return
      }
      let collect = (data.collect_info && data.collect_info.is_collect) || 0
      let num = (data.collect_info && data.collect_info.collect_num) || 0
      let params = {
        collect_type: 1,
        content_id: data.id,
        is_collect: +!collect
      }
      this.$http
        .postBaseApp('member/Collect/operateCollect', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            data.collect_info.is_collect = !collect
            let tips = ''
            if (collect) {
              data.collect_info.collect_num = num - 1 < 0 ? 0 : num - 1
              tips = '已取消收藏'
            } else {
              data.collect_info.collect_num = num + 1
              tips = '收藏成功'
            }
            this.$toast(tips)
          } else {
            this.$toast(res.msg)
          }
        })
    },
    bindStop() {},
    //切换显示更多营养素
    bindMoreNutrition(index) {
      this.superFoodList[index].showMoreNutrition =
        !this.superFoodList[index].showMoreNutrition
    },
    openItem(index, change) {
      this.superFoodList[index].open = true
      if (change) {
        this.changeSuperFoodData(index, true)
      }
    },
    closeItem(index, change) {
      this.superFoodList[index].open = false
      //关闭卡片时滚动到顶部
      let dom = this.$refs['cardItem' + index]
      dom = Array.isArray(dom) ? dom[0] : dom
      dom.scrollTop = 0
      if (change) {
        this.changeSuperFoodData(index, false)
      }
    },
    toggleItem(index, change) {
      this.superFoodList[index].open = !this.superFoodList[index].open
      if (change) {
        this.changeSuperFoodData(index, this.superFoodList[index].open)
      }
    },
    bindShare(type) {
      this.setShare()
      if (type === 1) {
        this.shareFriend()
      } else if (type === 2) {
        this.shareWechat()
      }
    },
    //分享微信好友
    shareFriend() {
      let desc = this.superFoodList[this.activeIndex].data.s_suggest_desc
      desc =
        (desc &&
          desc.length &&
          this.superFoodList[this.activeIndex].data.s_suggest_desc[0]) ||
        ''
      let title =
        '#betterWE食物档案库#你不了解的' +
        this.superFoodList[this.activeIndex].data.name
      let thumbnail =
        this.superFoodList[this.activeIndex].data.thumb_image_url || ''
      this.$betterwe.onAppShare({
        shareType: 1, //分享的类型 1 微信好友 2 微信朋友圈
        contentType: 'url', //分享的数据类型  image 分享图片  url 分享H5链接
        // 分享的数据
        shareData: {
          data: this.getShareUrl(), //分享的具体数据
          //分享的数据的格 式
          //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
          type: 'url',
          desc,
          title,
          thumbnail // 分享的缩略图的url
        }
      })
    },
    getShareUrl() {
      let url = location.href
      if (url.indexOf('id=') < 0) {
        if (url.indexOf('?') >= 0) {
          url = url + '&id=' + this.superFoodList[this.activeIndex].foodId
        } else {
          url = url + '?id=' + this.superFoodList[this.activeIndex].foodId
        }
      }
      return url
    },
    //分享到微信朋友圈
    shareWechat() {
      let desc =
        this.superFoodList[this.activeIndex].data.s_suggest_desc.length &&
        this.superFoodList[this.activeIndex].data.s_suggest_desc[0]
      let title =
        '#betterWE食物档案库#你不了解的' +
        this.superFoodList[this.activeIndex].data.name
      let thumbnail =
        this.superFoodList[this.activeIndex].data.thumb_image_url || ''
      this.$betterwe.onAppShare(
        JSON.stringify({
          shareType: 2, //分享的类型 1 微信好友 2 微信朋友圈
          contentType: 'url', //分享的数据类型  image 分享图片  url 分享H5链接
          // 分享的数据
          shareData: {
            data: this.getShareUrl(), //分享的具体数据
            //分享的数据的格 式
            //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
            type: 'url',
            desc,
            title,
            thumbnail // 分享的缩略图的url
          }
        })
      )
    },
    setShare() {
      this.$http
        .getApp('member/Foods/shareInc', {
          foodid: this.superFoodList[this.activeIndex].data.id || ''
        })
        .then(
          (res) => {
            if (res.data.code === 200) {
              this.superFoodList[this.activeIndex].data.s_share_num =
                this.superFoodList[this.activeIndex].data.s_share_num + 1
            } else {
            }
          },
          (err) => {}
        )
    },
    //查看更多菜谱
    reviewMoreMenu(index) {
      if (
        !this.superFoodList[index].data ||
        !this.superFoodList[index].data.s_cookbook_img ||
        this.superFoodList[index].data.s_cookbook_img.length < 2
      ) {
        this.$toast('没有更多菜谱了')
        return
      }
      //如果当前菜谱小于菜谱列表则加1
      if (
        this.superFoodList[index].curMenuIndex <
        this.superFoodList[index].data.s_cookbook_img.length - 1
      ) {
        this.superFoodList[index].curMenuIndex =
          this.superFoodList[index].curMenuIndex + 1
      } else {
        this.superFoodList[index].curMenuIndex = 0
      }
      let dom = this.$refs['superMenu' + index]
      dom = Array.isArray(dom) ? dom[0] : dom
      dom.scrollIntoView()
    },
    removeCardTouch() {
      let container = document.getElementById('super-food')
      //手指接触屏幕
      container.removeEventListener('touchstart', this.cardTouchStart, false)
      container.removeEventListener('touchmove', this.cardTouchMove, false)
      //手指离开屏幕
      container.removeEventListener('touchend', this.cardTouchEnd, false)
    },
    bindTouchDom(id) {
      let container = document.getElementById(id)
      //手指接触屏幕
      container.addEventListener('touchstart', this.pageTouchStart, false)
      container.addEventListener('touchmove', this.pageTouchMove, false)
      //手指离开屏幕
      container.addEventListener('touchend', this.pageTouchEnd, false)
    },
    //获得角度
    getAngle(angx, angy) {
      return (Math.atan2(angy, angx) * 180) / Math.PI
    },
    //根据起点终点返回方向 1向上滑动 2向下滑动 3向左滑动 4向右滑动 0点击事件
    getDirection(startx, starty, endx, endy) {
      var angx = endx - startx
      var angy = endy - starty
      var result = 0
      //如果滑动距离太短
      if (Math.abs(angx) < 2 && Math.abs(angy) < 2) {
        return result
      }
      var angle = this.getAngle(angx, angy)
      if (angle >= -135 && angle <= -45) {
        result = 1
      } else if (angle > 45 && angle < 135) {
        result = 2
      } else if (
        (angle >= 135 && angle <= 180) ||
        (angle >= -180 && angle < -135)
      ) {
        result = 3
      } else if (angle >= -45 && angle <= 45) {
        result = 4
      }
      return result
    },
    pageTouchStart(e) {
      this.cardInfo.startx = e.touches[0].pageX
      this.cardInfo.starty = e.touches[0].pageY
      this.cardInfo.prey = e.touches[0].pageY
    },
    pageTouchMove(e) {
      var cury
      cury = e.changedTouches[0].pageY
      let direction
      if (cury > this.cardInfo.prey) {
        direction = 2
      } else {
        direction = 1
      }
      this.cardInfo.prey = cury
      switch (direction) {
        case 0:
          break
        case 1:
          //当滑动底部的时候禁止页面默认滑动行为
          if (
            /* this.isToBottom() || */
            !this.superFoodList[this.swiper.activeIndex].open
          ) {
            //e.preventDefault();
          }
          break
        case 2:
          //当滑动顶部的时候禁止页面默认滑动行为
          if (this.isToTop()) {
            e.preventDefault()
          }
          break
        case 3:
          break
        case 4:
          break
        default:
          break
      }
    },
    pageTouchEnd(e) {
      var endx, endy
      endx = e.changedTouches[0].pageX
      endy = e.changedTouches[0].pageY
      if (Math.abs(this.cardInfo.starty - endy) < 30) {
        return
      }
      var direction = this.getDirection(
        this.cardInfo.startx,
        this.cardInfo.starty,
        endx,
        endy
      )
      switch (direction) {
        case 0:
          break
        case 1:
          if (this.superFoodList[this.swiper.activeIndex].open) {
            return
          }
          this.openItem(this.swiper.activeIndex, true)
          break
        case 2:
          if (
            !this.superFoodList[this.swiper.activeIndex].open ||
            (this.isTouchCard(e.target) && !this.isToTop())
          ) {
            return
          }
          this.closeItem(this.swiper.activeIndex, true)
          break
        case 3:
          break
        case 4:
          break
        default:
          break
      }
    },
    //滑动方向
    scrollDirection(prey, cury) {
      if (prey < cury) {
        return 'bottom'
      }
      return 'top'
    },
    //卡片是否到底了
    isToBottom() {
      let dom = this.$refs['cardItem' + this.activeIndex]
      dom = Array.isArray(dom) ? dom[0] : dom
      if (dom && dom.scrollTop >= dom.scrollHeight - dom.offsetHeight) {
        return true
      }
      return false
    },
    // 卡片是否到顶部了
    isToTop() {
      let dom = this.$refs['cardItem' + this.activeIndex]
      dom = Array.isArray(dom) ? dom[0] : dom
      if (dom && dom.scrollTop <= 0) {
        return true
      }
      return false
    },
    //是否是滑动的卡片区域
    isTouchCard(target) {
      while (target.parentElement) {
        if (
          target.className &&
          typeof target.className == 'string' &&
          target.className.indexOf('item-card') >= 0
        ) {
          return true
        }
        target = target.parentElement
      }
      return false
    },
    //改变超级食物的渲染数据
    changeSuperFoodData(index, isOpen) {
      let data = this.superFoodList[index].data
      if (isOpen) {
        data.tagList = data.s_light_desc
      } else {
        data.tagList = this.filterTagList(data.s_light_desc)
      }
    },
    //处理超级食物数据
    filterSuperFoodDetail(data) {
      if (data.is_super) {
        data.s_suggest_coach_title = Array.isArray(data.s_suggest_coach_title)
          ? data.s_suggest_coach_title.join('、')
          : ''
        data.calory = parseInt(data.calory) || 0
        data.gi = parseFloat(data.gi)
        data.gl = parseFloat(data.gl)
        data.tagList = this.filterTagList(
          Array.isArray(data.s_light_desc) ? data.s_light_desc : []
        )
      }
      return data
    },
    //处理收起时一行能显示几个亮点
    filterTagList(arr) {
      let total = this.tagSizeInfo.tagContainerWidth
      let curTotal = 0
      let num = 0 //能放几个标签
      for (let i = 0; i < arr.length; i++) {
        let width = 0
        let textWidth = this.getTextWidth(arr[i], this.tagSizeInfo.fontSize)
        width =
          textWidth +
          this.tagSizeInfo.tagPadding * 2 +
          this.tagSizeInfo.tagMargin * 2
        curTotal = curTotal + width
        if (curTotal <= total) {
          num = i + 1
        } else {
          break
        }
      }
      let res = arr.slice(0, num)
      return res
    },
    //获取一行文字的宽度
    getTextWidth(text, font) {
      const dom = document.createElement('span')
      dom.style.display = 'inline-block'
      dom.style.opacity = 0
      dom.style.fontSize = font + 'px'
      dom.textContent = text
      document.body.appendChild(dom)
      const width = dom.clientWidth
      document.body.removeChild(dom)
      return width
    },
    //获取超级食物详情
    getSuperFood(foodId) {
      if (this.$http._isApp()) {
        this.$http
          .postBaseApp('member/Food/superFood', {
            foodid: foodId || ''
          })
          .then(
            (res) => {
              this.dealRes(res, foodId)
            },
            (err) => {}
          )
          .catch((err) => {
            console.log(err)
          })
          .finally(() => {
            this.loaded = true
            this.$nextTick(() => {
              this.getParams()
            })
          })
      } else {
        this.$http
          .getApp('member/Foods/superFood', {
            foodid: foodId || ''
          })
          .then(
            (res) => {
              this.dealRes(res, foodId)
            },
            (err) => {}
          )
          .catch((err) => {
            console.log(err)
          })
          .finally(() => {
            this.loaded = true
            this.$nextTick(() => {
              this.getParams()
            })
          })
      }
    },
    dealRes(res, foodId) {
      if (res.data.code === 200) {
        if (!res.data.data.super_list) {
          this.$toast('未获取到超级食物')
          return
        }
        if (!this.isInit) {
          if (this.$route.query.name) {
            //如果获取到的是指定食物
            let data = {
              super_list: [res.data.data.super_food.id],
              super_food: res.data.data.super_food
            }
            this.initSuperFoodData(data)
            this.getSuperMenu()
            this.getBannerList()
          } else {
            if (res.data.data.super_list) {
              //如果是随机超级食物
              this.initSuperFoodData(res.data.data)
              this.getSuperMenu()
              this.getBannerList()
            }
          }
          this.initSwiper()
          this.isInit = true
        } else {
          this.addSuperFoodData(foodId, res.data.data.super_food)
          this.getSuperMenu()
          this.getBannerList()
        }
      } else {
        this.$dialog.alert({
          title: '提示',
          message: res.data.msg
        })
      }
    },
    //初始化超级食物列表数据
    initSuperFoodData(data) {
      let res = []
      let cur = this.filterSuperFoodDetail(data.super_food)
      let idList = data.super_list
      idList.map((item, index) => {
        if (index == 0) {
          let obj = {
            foodId: item,
            loaded: true,
            loading: false,
            finished: false,
            page: 1,
            open: false,
            showMoreNutrition: false,
            curMenuIndex: 0, //当前超级食谱index
            data: cur,
            superMenuList: [],
            advData: [], //资源位数据
            advLoaded: false //资源位是否加载过
          }
          res.push(obj)
        } else {
          let obj = {
            foodId: item,
            loaded: false,
            loading: false,
            finished: false,
            page: 1,
            open: false,
            showMoreNutrition: false,
            curMenuIndex: 0,
            data: null,
            superMenuList: [],
            advData: [],
            advLoaded: false //资源位是否加载过
          }
          res.push(obj)
        }
      })
      this.superFoodList = res
    },
    //添加超级食物数据
    addSuperFoodData(foodId, data) {
      data = this.filterSuperFoodDetail(data)
      for (let i = 0; i < this.superFoodList.length; i++) {
        if (this.superFoodList[i].foodId === foodId) {
          this.superFoodList[i].loaded = true
          this.$set(this.superFoodList[i], 'data', data)
          return
        }
      }
    },
    //卡片滚动
    bindCardScroll(e) {
      let target = e.target
      if (target.scrollTop >= target.scrollHeight - target.offsetHeight - 200) {
        this.getSuperMenu()
      }
    },
    getSuperMenu() {
      if (
        !this.$http._isApp() ||
        this.superFoodList[this.activeIndex].loading ||
        this.superFoodList[this.activeIndex].finished
      ) {
        return
      }
      let item = this.superFoodList[this.activeIndex]
      item.loading = true
      let params = {
        page: item.page,
        pagenum: 20,
        cal_food_id: item.foodId
      }
      this.$http
        .getApp('member/SuperRecipe/getSuperRecipePageByCalFood', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            if (!res.data.data.length) {
              item.finished = true
            } else {
              item.page++
            }
            item.superMenuList = item.superMenuList.concat(res.data.data)
          } else {
            this.$toast(res.msg)
            item.finished = true
          }
        })
        .catch((err) => {})
        .finally(() => {
          item.loading = false
        })
    },
    //获取资源位列表
    getBannerList() {
      if (!this.$http._isApp()) {
        return
      }
      let index = this.activeIndex
      if (this.superFoodList[index].advLoaded) {
        return
      }
      let params = {
        lab_ids: this.superFoodList[index].foodId, //食物id
        position_type: '17', //位置类型
        resource_type: '2' //资源位类型
      }
      this.$http
        .getAdvData(
          'member/ResourceLocation/getShowResourceLocationNew',
          params
        )
        .then((res) => {
          res = res.data
          if (res.code === 200) {
            this.superFoodList[index].advData = res.data
            this.superFoodList[index].advLoaded = true
          }
        })
        .catch((err) => {})
    },
    bindJumpRecipe(index, menuindex) {
      if (this.$http._isApp()) {
        this.$betterwe.onAppPageUrlRoute(
          '/recipeDetails?id=' +
            this.superFoodList[index].superMenuList[menuindex].id
        )
      } else {
        this.$toast('请前往APP打开')
      }
    },
    bindMore() {
      if (this.$http._isApp()) {
        this.$betterwe.checkAppUpdate(38)
        this.$betterwe.onAppPageUrlRoute('/recipeHome')
      } else {
        this.$toast('请前往APP打开')
      }
    },
    async getCommonIncomingUrl() {
      let res = await this.$http
        .getBaseApp('api/v3/expert/getCommonIncomingUrl', { source_type: 3 })
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.CommonIncomingData = res.data
        }
      }
    },
    jumpToStarPage() {
      this.$betterwe.jumpRoute(this.CommonIncomingData.router)
    },
    jumpIncoming() {
      this.$betterwe.jumpRoute(this.CommonIncomingData.incoming_url)
    }
  }
}
</script>
<style lang="scss">
.super-food {
  .van-hairline--bottom::after {
    border: none;
  }

  .van-nav-bar {
    .van-icon {
      color: #000;
      font-size: 16px;
      font-weight: 600;
    }

    .van-nav-bar__content {
      height: 44px;
    }
  }
}
</style>
<style lang="scss" scoped>
.super-food {
  background-color: #f9f9f9;
  height: 100vh;
  box-sizing: border-box;
  transition: background-color 1s ease;
}

.food-title {
  position: fixed;
  left: 30px;
  top: 30px;
  z-index: 10;
  font-size: 24px;
  font-family: Alibaba-PuHuiTi-B, Alibaba-PuHuiTi;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.4);
  line-height: 33px;
}

.nav-bar::v-deep {
  position: sticky;
  top: 0;
  width: 100%;
  background-color: transparent;

  .van-nav-bar__title {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 25px;
  }
}

.nav-bar::v-deep .van-hairline--bottom::after {
  border: none;
}

.detail-container {
  position: relative;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-end;
}

.container-bottom {
  flex: 1;
  flex-shrink: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-end;
}

.swiper {
  width: 100%;
}

.mySwiper {
  width: 100%;
  overflow: hidden;
}

.swiper-wrapper {
  align-items: flex-end;
}

/* 每个轮播图占比大小，100%则整个屏幕铺满 */
.swiper-slide {
  width: 84%;
  height: auto;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.swiper-slide-prev {
  transform: scale(0.9);
}

.swiper-slide-next {
  transform: scale(0.9);
}

.swiper-slide ::v-deep .swiper-slide-shadow-left {
  display: none;
}

.swiper-slide ::v-deep .swiper-slide-shadow-right {
  display: none;
}

.card-container {
  width: 100%;
  border-radius: 20px;
  overflow: hidden;

  .more {
    text-align: center;
    margin-bottom: 9px;
    font-size: 13px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.5);
    line-height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;

    .iconfont {
      margin-left: 2px;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.5);
    }
  }

  .item-card {
    width: 100%;
    position: relative;
    height: calc(0.523 * (100vh - 64px));
    transition: height 0.3s ease;
    background: #fff;
    box-shadow: 0px 6px 8px 0px rgba(151, 100, 44, 0.2);
    border-radius: 20px;
    overflow: hidden;

    .card-loading {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    .card-show {
      width: 100%;
      height: 100%;
      padding-top: 20px;
      display: flex;
      flex-direction: column;
      position: relative;
      box-sizing: border-box;
    }

    .card-icon {
      width: 100%;
      top: 0;
      left: 0;
      position: absolute;
      display: flex;
      align-items: center;
      flex-direction: column;
      padding-top: 4px;
      padding-bottom: 9px;

      .icon-1 {
        width: 18px;
        height: 2px;
        background: #e1e1e1;
        border-radius: 2px;
        margin-bottom: 2px;
      }

      .icon-2 {
        width: 10px;
        height: 2px;
        background: #e1e1e1;
        border-radius: 2px;
      }
    }

    .card-flex {
      width: 100%;
      flex: 1;
      flex-shrink: 0;
      overflow-y: scroll;
      box-sizing: border-box;
      position: relative;

      .c-padding {
        padding: 0px 20px;
        box-sizing: border-box;
      }

      .tip {
        width: 100%;
        text-align: left;
        margin-bottom: 16px;
        font-size: 12px;
        line-height: 18px;
        color: rgba(0, 0, 0, 0.4);
      }

      .card-title {
        margin-bottom: 4px;
        font-size: 14px;
        font-family: YouSheBiaoTiHei;
        color: rgba(0, 0, 0, 0.2);
        line-height: 18px;

        .title1 {
          margin-right: 4px;
          font-weight: 600;
        }

        .title2 {
          font-size: 10px;
          font-style: italic;
        }
      }

      .card-top {
        padding-bottom: 15px;
        border-bottom: 1px solid #f1f1f1;
        display: flex;
        align-items: center;

        .top-left {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          display: flex;
          align-items: flex-end;
          margin-right: 5px;
        }

        .food-name {
          max-width: 200px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 28px;
          font-family: Alibaba-PuHuiTi-B, Alibaba-PuHuiTi;
          font-weight: 600;
          color: #000000;
          // line-height: 38px;
          margin-right: 5px;
        }

        .food-type {
          white-space: nowrap;
          font-size: 12px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.5);
          line-height: 24px;
        }

        .collect-box {
          max-width: 40px;

          .collect {
            width: 24px;
            height: 24px;
            object-fit: contain;
          }

          .collect-num {
            margin-top: 2px;
            text-align: center;
            font-size: 10px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.5);
            line-height: 14px;
          }
        }
      }

      .item-cal {
        padding: 2px 3px;
        box-sizing: border-box;
        border-bottom: 1px solid #f1f1f1;
        font-family: PingFangSC-Regular, PingFang SC;
        margin-bottom: 16px;

        .cal-100unit {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
          line-height: 17px;
        }

        .cal-num {
          font-size: 30px;
          font-family: GothamMedium;
          color: #000000;
          line-height: 33px;
          margin-right: 8px;
        }

        .cal-unit {
          font-size: 12px;
          font-weight: 600;
          color: #000000;
          line-height: 17px;
        }
      }

      .tag-list {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 7px;

        .tag-item {
          padding: 7px 12px;
          font-size: 12px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 17px;
          display: inline-block;
          white-space: nowrap;
          background: #ececec;
          border-radius: 15px;
          margin: 4px;
        }
      }

      .recommend-list {
        text-align: left;
        margin-bottom: 20px;

        .recommend-item {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.8);
          line-height: 24px;
          padding-left: 23px;
          position: relative;
          margin-bottom: 8px;
        }

        .recommend-item:last-child {
          margin-bottom: 0px;
        }

        .recommend-item::after {
          content: '';
          width: 8px;
          height: 8px;
          background: #d8d8d8;
          border-radius: 50%;
          position: absolute;
          left: 5px;
          top: 12px;
          transform: translate(0%, -50%);
        }
      }

      .gray-item {
        background: #f9f9f9;
        border-radius: 16px;
        margin-bottom: 16px;

        .item-title {
          text-align: center;
          font-size: 18px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #000000;
          line-height: 24px;
          margin-bottom: 3px;
        }

        .item-desc {
          text-align: center;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.5);
          line-height: 17px;
          margin-bottom: 20px;
        }
      }

      .food-cal {
        padding: 19px 0px 4px;
        text-align: center;

        .circle-container {
          margin: 0 auto;
          width: 220px;
          /*  height: 186px; */
          overflow: hidden;
        }
      }

      .nutrition-container {
        text-align: center;
        padding: 17px 13px 14px;

        .nutrition-box {
          .nutrition-item {
            padding: 0px 18px;
            display: flex;
            align-items: center;
            height: 34px;
            border-radius: 4px;

            .item-name {
              text-align: left;
              flex: 1;
              flex-shrink: 0;
              overflow: hidden;
              margin-right: 10px;
              font-size: 12px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: rgba(0, 0, 0, 0.8);
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }

            .item-unit {
              min-width: 60px;
              max-width: 100px;
              margin-right: 10px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.5);
              line-height: 34px;
            }

            .item-percent {
              text-align: center;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #000000;
              line-height: 34px;
              min-width: 40px;
            }
          }

          .nutrition-item:nth-child(2n + 1) {
            background: #ffffff;
          }

          .nutrition-item-title {
            text-align: left;
            padding: 0px 13px;
            height: 30px;
            background: #272727 !important;
            border-radius: 4px;
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 30px;

            .item-name,
            .item-unit,
            .item-percent {
              color: #fff;
            }
          }

          .look-more {
            margin-top: 13px;

            .text {
              margin-right: 6px;
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #0a0a0a;
              line-height: 20px;
            }

            .iconfont {
              display: inline-flex;
              align-items: center;
              justify-content: center;
              color: #999;
              font-size: 10px;
              width: 16px;
              height: 16px;
              background: #ffffff;
              border: 1px solid #f1f1f1;
              border-radius: 50%;
              transition: transform 0.3s ease;
            }

            .rotate {
              transform: rotate(180deg);
            }
          }
        }
      }

      .bloodsugar-container {
        text-align: center;
        padding: 16px 10px 27px;

        .bloodsugar-list {
          display: flex;
          align-items: center;
          justify-content: center;

          .bloodsugar-item {
            text-align: center;
            width: 86px;
            background: #ffffff;
            border-radius: 16px;
            border: 1px solid #eceaf0;
            overflow: hidden;
            margin-right: 24px;

            .item-title {
              height: 38px;
              padding-top: 4px;
              box-sizing: border-box;
              line-height: 34px;
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #ffffff;
              background: #272727;
            }

            .item-number {
              font-size: 24px;
              font-family: DINCondensed-Bold, DINCondensed;
              color: #272727;
              line-height: 34px;
              margin-top: 8px;
              margin-bottom: 7px;
            }

            .item-desc {
              font-size: 13px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #000000;
              line-height: 18px;
            }
          }

          .bloodsugar-item:last-child {
            margin-right: 0;
          }
        }
      }

      .edible-advice {
        text-align: center;
        padding: 23px 18px 19px;
      }

      .adv-content {
        margin-bottom: 16px;
      }

      .super-menu {
        padding: 19px 18px;

        .super-menu-image {
          width: 100%;
          margin-bottom: 16px;
        }

        .menu-list {
          .menu-item {
            background-color: #fff;
            border-radius: 16px;
            overflow: hidden;
            margin-bottom: 16px;

            .item-pic {
              width: 100%;
              height: 242px;
              object-fit: cover;
            }

            .item-name {
              font-size: 16px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #000000;
              line-height: 22px;
            }

            .menu-desc {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.7);
              line-height: 19px;
              margin-bottom: 17px;
            }

            .item-bottom {
              padding: 10px 14px 16px;
              box-sizing: border-box;
              font-size: 10px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #aeaeae;
              line-height: 14px;
            }

            .item-star {
              display: flex;
              align-items: center;

              .item-diff {
                margin-right: 4px;
              }

              .star {
                margin-right: 10px;
              }
            }
          }
        }

        .look-more {
          text-align: center;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #0a0a0a;
          line-height: 20px;

          .text {
            margin-right: 10px;
          }

          .rotate90 {
            transform: rotate(-90deg);
            transform-origin: center center;
          }

          .iconfont {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            color: #999;
            font-size: 10px;
            width: 16px;
            height: 16px;
            background: #ffffff;
            border: 1px solid #f1f1f1;
            border-radius: 50%;
            transition: transform 0.3s ease;
          }
        }
      }
    }

    .card-scroll {
      overflow-y: scroll;
    }

    .card-bottom {
      position: relative;
      background: #272727;
      padding: 12px 20px 16px;
      display: flex;
      align-items: center;
      overflow: hidden;

      .avatar {
        width: 36px;
        height: 36px;
        background: #efe1ff;
        object-fit: cover;
        border-radius: 12px;
        overflow: hidden;
        margin-right: 9px;
      }

      .bottom-right {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;

        .nickname {
          font-size: 12px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: bold;
          color: #ffffff;
          line-height: 20px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .desc {
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(255, 255, 255, 0.8);
          line-height: 14px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }

      .b-btn {
        width: 74px;
        height: 31px;
        background: linear-gradient(149deg, #9071ff 0%, #7d9afc 100%);
        border-radius: 16px;
        line-height: 31px;
        text-align: center;
        font-weight: bold;
        font-size: 12px;
        color: #ffffff;
      }
    }

    .card-bottom::after {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-top: 8px solid #fff;
      top: -1px;
      left: 30px;
    }
  }

  .item-card-open {
    width: 100%;
    height: calc(0.846 * (100vh - 64px));
  }
}

/* 滑动到当前轮播图的样式 解决swiper当前轮播图rotateY在约等于0时导致点击位置不准的问题 */
.swiper-slide-active {
  transform: rotateY(0deg) !important;
}

.food-image-container {
  position: absolute;
  left: 0;
  top: 0px;
  width: 100%;
  height: calc(0.43 * (100vh - 64px));
  overflow: hidden;
  padding: 22px 30px 0px;
  box-sizing: border-box;
  transition: height 0.3s ease;

  .food-image-padding {
    height: 100%;
    position: relative;
  }

  .food-text-image {
    height: 80%;
    position: absolute;
    box-sizing: border-box;
    object-fit: contain;
    width: 100%;
    bottom: 10%;
    left: 50%;
    z-index: 2;
    transform: translate(-50%, 0%);
    transition: height 0.3s ease;
  }

  .food-image {
    position: absolute;
    box-sizing: border-box;
    object-fit: contain;
    width: 100%;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 0%);
    height: 100%;
    object-fit: contain;
    z-index: 1;
    transition: height 0.3s ease;
  }
}

.food-image-container-open {
  height: calc(0.154 * (100vh - 64px));
  padding: 11px 30px;

  .food-text-image {
    height: 70%;
  }

  .food-image {
    height: 100%;
  }
}

.bottom {
  width: 100%;
  height: 64px;
  text-align: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  .download-container {
    position: absolute;
    box-sizing: border-box;
    width: 100%;
    left: 0;
    bottom: 0;
    padding: 10px 30px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    background-color: #fff;

    .betterwe-logo {
      width: 40px;
      height: 40px;
      border-radius: 12px;
      overflow: hidden;
      margin-right: 10px;
    }

    .center {
      text-align: left;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
      line-height: 20px;
    }

    .app-btn {
      height: 35px;
      background: #000;
      border-radius: 10px;
      font-size: 13px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      padding: 0px 18px;
      color: #ffffff;
      line-height: 35px;
      margin-left: 10px;
    }
  }

  .logo {
    width: 91px;
  }
}

.v-loading {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

//app时
.super-food-app {
  padding-top: 83px;

  .item-card {
    height: calc(0.523 * (100vh - 64px - 83px));
  }

  .item-card-open {
    height: calc(0.846 * (100vh - 64px - 83px));
  }

  .food-image-container {
    height: calc(0.43 * (100vh - 64px - 83px));
  }

  .food-image-container-open {
    height: calc(0.154 * (100vh - 64px - 83px));
  }
}

.space-loading {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 88;
  box-sizing: border-box;
  padding-bottom: 64px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  background: #f1f1f1;

  .more {
    text-align: center;
    margin-bottom: 9px;
    font-size: 13px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.5);
    line-height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;

    .iconfont {
      margin-left: 2px;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.5);
    }
  }

  .space-content {
    width: 84%;
    height: calc(0.523 * (100vh - 64px));
    background: #fff;
    border-radius: 20px;
    overflow: hidden;
    padding: 43px 28px;
    box-sizing: border-box;

    .radius-content {
      margin-bottom: 45px;
    }

    .item {
      display: flex;
      align-items: center;

      .gray {
        background: #f1f1f1;
        position: relative;
        overflow: hidden;
        border-radius: 2px;
        backface-visibility: hidden;
        transform: translate3d(0, 0, 0);
      }

      .gray::after {
        content: '';
        background: linear-gradient(
          315deg,
          rgba(248, 248, 248, 1) 0%,
          rgba(248, 248, 248, 0) 100%
        );
        position: absolute;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        animation: myLinear 1s ease infinite;
      }

      .gray-radius {
        height: 26px;
        border-radius: 13px;
        margin-right: 7px;
        overflow: hidden;
      }

      .radius-1 {
        width: 48px;
      }

      .radius-2 {
        width: 90px;
      }

      .radius-3 {
        width: 71px;
      }

      .gray-1 {
        width: 83px;
        height: 20px;
        border-radius: 2px;
        margin-bottom: 13px;
      }

      .gray-2 {
        width: 166px;
        height: 20px;
        border-radius: 2px;
        margin-bottom: 13px;
      }

      .gray-3 {
        width: 205px;
        height: 16px;
        border-radius: 2px;
        margin-bottom: 14px;
      }

      .gray-4 {
        width: 195px;
        height: 16px;
        margin-bottom: 14px;
        border-radius: 2px;
      }

      .gray-5 {
        width: 238px;
        height: 16px;
        border-radius: 2px;
      }
    }
  }
}

.share-btn {
  width: 24px;
  height: 24px;
  object-fit: contain;
  font-size: 20px;
}

@keyframes myLinear {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
